<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'MyMeetingsDataProvider',
  props: {
    tab: { type: String, default: 'upcoming' }
  },
  created() {
    this.setTab(this.tab);
    this.fetchTab(this.tab);
  },
  watch: {
    tab(newTab) {
      this.setTab(newTab);
      this.fetchTab(newTab);
    }
  },
  methods: {
    ...mapMutations('MyMeetings', ['setTab']),
    ...mapActions('MyMeetings', [
      'fetchTab',
      'cancelMeeting',
      'acceptMeeting',
      'declineMeeting'
    ])
  },
  computed: {
    ...mapGetters('MyMeetings', [
      'getItems',
      'getItemsByTab',
      'isLoading',
      'failed',
      'pendingCount',
      'upcomingCount'
    ])
  },
  render() {
    return this.$scopedSlots.default({
      meetings: this.getItems,
      meetingsByTab: this.getItemsByTab,
      loading: this.isLoading,
      failed: this.failed,
      pendingCount: this.pendingCount,
      upcomingCount: this.upcomingCount,
      refresh: () => this.fetchTab(this.tab),
      cancelMeeting: (payload) => this.cancelMeeting(payload),
      acceptMeeting: (payload) => this.acceptMeeting(payload),
      declineMeeting: (payload) => this.declineMeeting(payload)
    });
  }
};
</script>
